@if (config) {
    <generic-list-manager [config]="config"> </generic-list-manager>
} @else {
    <div class="fancy-loader submodule"></div>
}
